/* eslint-disable react/jsx-no-target-blank */
import {KTIcon} from '../../../helpers'

const SidebarFooter = () => {
  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <a
        // href={process.env.REACT_APP_PREVIEW_DOCS_URL}
        target='_blank'
        className='d-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        data-bs-dismiss-='click'
        title='Metronic Docs & Components'
      >
        <span className='btn-label'>Versão 1.0</span>
        <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
      </a>
      <div className='d-lg-none text-center mt-4'>
        <span className='text-muted fw-semibold me-1'>
          {new Date().getFullYear().toString()}&copy;
        </span>
        <span className='text-gray-800 fw-semibold'>Magma Pro</span>
      </div>
    </div>
  )
}

export {SidebarFooter}
